import styled from 'styled-components';
import Wra16A from 'dc/Wra16A';
import { Typ20, Typ42 } from 'dc/Typ';
import Lab010 from 'dc/Lab010';
import APH120B from 'dc/APH120B';
import { ShortWrapper } from '../elements';

export const Wrapper = styled(ShortWrapper)`
  background: #ffffff;
`;

export const ProfileWrapper = styled(Wra16A)`
  width: 100%;
`;

export const Header = styled(APH120B)`
  > i {
    color: #00ab97;
  }

  > div > i {
    color: ${props =>
      props.rightIcon === 'icon-crown' ? '#ffc107' : '#00ab97'};
  }
`;

export const CurrentPositionWrapper = styled(Wra16A)`
  background: ${props => (props.positionDecreased ? '#f4f7f9' : '#007565')};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

type SmallTextProps = {
  positionDecreased?: boolean;
};

export const SmallText = styled(Typ20)<SmallTextProps>`
  text-align: center;
  color: ${props => (props.positionDecreased ? '#263238' : '#fff')};
`;

type MainTextProps = {
  positionDecreased?: boolean;
};

export const MainText = styled(Typ42)<MainTextProps>`
  margin-top: 16px;
  text-align: center;
  color: ${props => (props.positionDecreased ? '#263238' : '#fff')};
`;

export const PositionChangeWrapper = styled(Wra16A)`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const PositionChangeLabel = styled(Lab010)`
  > span {
    color: #607d8b;
  }

  > i {
    color: ${props =>
      props.icon === 'icon-arrow_downward' ? '#d9464d' : '#00ab97'};
  }
`;
